class SearchScrollHide extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-hide-on-scroll')) return;

    this.lastY = window.scrollY;
    this.ticking = false;
    this.hidden = false;
    this.threshold = 10;
    this.topZone = 80;
    this.settling = false;

    this._onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this._onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
  }

  setHidden(shouldHide) {
    if (shouldHide === this.hidden) return;
    this.hidden = shouldHide;
    this.classList.toggle('header__search-wrapper--hidden', shouldHide);
    this.settling = true;
    clearTimeout(this._settleTimer);
    this._settleTimer = setTimeout(() => {
      this.settling = false;
      this.lastY = Math.max(0, window.scrollY);
    }, 250);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;

    requestAnimationFrame(() => {
      this.ticking = false;
      if (this.settling) return;

      const searchActive =
        document.documentElement.classList.contains('nosto-search-active') ||
        document.activeElement?.id === 'search-header-input';

      if (searchActive) return;

      const y = Math.max(0, window.scrollY);

      if (y <= this.topZone) {
        this.setHidden(false);
        this.lastY = y;
        return;
      }

      const delta = y - this.lastY;

      if (Math.abs(delta) < this.threshold) return;

      this.setHidden(delta > 0);
      this.lastY = y;
    });
  }
}

customElements.define('search-scroll-hide', SearchScrollHide);
